import {
	createContext,
	ReactNode,
	useCallback,
	useContext,
	useState,
} from "react";

type LayoutProviderProps = {
	children: ReactNode;
};

type LayoutContextProps = {
	darkMode: "dark" | "light";
	turnDarkMode: () => void;
	turnLightMode: () => void;
};

export const LayoutContext = createContext({} as LayoutContextProps);

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
	const [darkMode, setDarkMode] = useState<"dark" | "light">(
		(localStorage.getItem("darkmode") as "dark" | "light") || "light"
	);

	const turnLightMode = useCallback(() => {
		setDarkMode("light")
		localStorage.setItem('darkmode', 'light')
	}, [setDarkMode]);

	const turnDarkMode = useCallback(() => {
		setDarkMode("dark")
		localStorage.setItem('darkmode', 'dark')
	}, [setDarkMode]);
	return (
		<LayoutContext.Provider
			value={{
				darkMode,
				turnLightMode,
				turnDarkMode,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};

export const useLayout = () => useContext(LayoutContext);
